import { DEFAULT_EMAIL_TEMPLATE_LIMIT, DEFAULT_POLICY_LIMIT, } from '../planMap';
export const CURRENT_PRICING_VERSION = `2026`;
export var StripeProducts;
(function (StripeProducts) {
    StripeProducts["Essentials"] = "essentials";
    StripeProducts["Pro"] = "pro";
    StripeProducts["OrgAddOn"] = "org_add_on";
})(StripeProducts || (StripeProducts = {}));
export var StripePricesLookupKeys;
(function (StripePricesLookupKeys) {
    StripePricesLookupKeys["Essentials50"] = "essentials-50";
    StripePricesLookupKeys["Essentials150"] = "essentials-150";
    StripePricesLookupKeys["Pro300"] = "pro-300";
    StripePricesLookupKeys["Pro600"] = "pro-600";
    StripePricesLookupKeys["Pro1000"] = "pro-1000";
    StripePricesLookupKeys["Pro2000"] = "pro-2000";
    StripePricesLookupKeys["Pro3000"] = "pro-3000";
    StripePricesLookupKeys["Pro4000"] = "pro-4000";
    StripePricesLookupKeys["OrgAddOn"] = "org-share";
    StripePricesLookupKeys["OrgAddOn29"] = "org-share-29";
    /** @deprecated */
    StripePricesLookupKeys["OriginalSMS"] = "original-sms";
    // 2026 April Pricing Update
    StripePricesLookupKeys["Essentials1502026"] = "essentials-150-2026";
    StripePricesLookupKeys["Pro3002026"] = "pro-300-2026";
    StripePricesLookupKeys["Pro6002026"] = "pro-600-2026";
    StripePricesLookupKeys["Pro10002026"] = "pro-1000-2026";
    StripePricesLookupKeys["Pro20002026"] = "pro-2000-2026";
    StripePricesLookupKeys["Pro30002026"] = "pro-3000-2026";
    StripePricesLookupKeys["Pro40002026"] = "pro-4000-2026";
    StripePricesLookupKeys["OrgAddOnMultiCurrency2026"] = "org-share-multicurrency-2026";
    StripePricesLookupKeys["Essentials1502026Annual"] = "essentials-150-2026-annual";
    StripePricesLookupKeys["Pro3002026Annual"] = "pro-300-2026-annual";
    StripePricesLookupKeys["Pro6002026Annual"] = "pro-600-2026-annual";
    StripePricesLookupKeys["Pro10002026Annual"] = "pro-1000-2026-annual";
    StripePricesLookupKeys["Pro20002026Annual"] = "pro-2000-2026-annual";
    StripePricesLookupKeys["Pro30002026Annual"] = "pro-3000-2026-annual";
    StripePricesLookupKeys["Pro40002026Annual"] = "pro-4000-2026-annual";
    StripePricesLookupKeys["OrgAddOn29Annual"] = "org-share-29-annual";
    // Manually managed SMS price - has multicurrency
    StripePricesLookupKeys["SmsManuallyManaged"] = "sms-manually-managed";
})(StripePricesLookupKeys || (StripePricesLookupKeys = {}));
export const plansV3 = {
    [StripeProducts.Essentials]: {
        name: `Essentials`,
        description: `Everything to automate late fees, discounts & more`,
        features: {
            webhooks: false,
            whitelabel: false,
            customDomain: false,
            multicurrency: false,
            statementInterest: true,
            statementEmails: true,
            multiEntityReporting: false,
            userPermissions: false,
            paymentPlans: false,
        },
        addOns: [],
        prices: {
            [StripePricesLookupKeys.Essentials50]: {
                version: `2025`,
                name: `Essentials 50`,
                previouslyNamed: `Mini`,
                description: `50 invoices + 250 emails each month.`,
                lookupKey: StripePricesLookupKeys.Essentials50,
                currency: `USD`,
                default: false,
                limits: {
                    actions: 25,
                    emails: 250,
                    invoices: 50,
                    contacts: 200,
                    policies: DEFAULT_POLICY_LIMIT,
                    emailTemplates: DEFAULT_EMAIL_TEMPLATE_LIMIT,
                    users: 3,
                },
            },
            [StripePricesLookupKeys.Essentials150]: {
                version: `2025`,
                name: `Essentials 150`,
                previouslyNamed: `Starter`,
                description: `150 invoices + 600 emails each month.`,
                lookupKey: StripePricesLookupKeys.Essentials150,
                currency: `USD`,
                default: true,
                limits: {
                    actions: 50,
                    emails: 600,
                    invoices: 150,
                    contacts: 400,
                    policies: DEFAULT_POLICY_LIMIT,
                    emailTemplates: DEFAULT_EMAIL_TEMPLATE_LIMIT,
                    users: 3,
                },
            },
            [StripePricesLookupKeys.Essentials1502026]: {
                version: `2026`,
                name: `Essentials 150`,
                previouslyNamed: `Starter`,
                description: `150 invoices + 600 emails each month.`,
                lookupKey: StripePricesLookupKeys.Essentials1502026,
                currency: `USD`,
                default: true,
                limits: {
                    actions: 50,
                    emails: 600,
                    invoices: 150,
                    contacts: 400,
                    policies: DEFAULT_POLICY_LIMIT,
                    emailTemplates: DEFAULT_EMAIL_TEMPLATE_LIMIT,
                    users: 2,
                },
            },
            [StripePricesLookupKeys.Essentials1502026Annual]: {
                version: `2026`,
                name: `Essentials 150 Annual`,
                previouslyNamed: `Starter`,
                description: `150 invoices + 600 emails each month, billed annually.`,
                lookupKey: StripePricesLookupKeys.Essentials1502026Annual,
                currency: `USD`,
                default: false,
                annual: true,
                hidden: true,
                limits: {
                    actions: 50,
                    emails: 600,
                    invoices: 150,
                    contacts: 400,
                    policies: DEFAULT_POLICY_LIMIT,
                    emailTemplates: DEFAULT_EMAIL_TEMPLATE_LIMIT,
                    users: 2,
                },
            },
        },
    },
    [StripeProducts.Pro]: {
        name: `Pro`,
        description: `Everything in Essentials, plus statement interest, custom domains & more. Better value for higher volumes.`,
        features: {
            webhooks: true,
            whitelabel: true,
            customDomain: true,
            multicurrency: true,
            statementInterest: true,
            statementEmails: true,
            multiEntityReporting: true,
            userPermissions: true,
            paymentPlans: true,
        },
        addOns: [
            StripePricesLookupKeys.OrgAddOn,
            StripePricesLookupKeys.OrgAddOn29,
            StripePricesLookupKeys.OrgAddOnMultiCurrency2026,
            StripePricesLookupKeys.OrgAddOn29Annual,
        ],
        prices: {
            [StripePricesLookupKeys.Pro300]: {
                version: `2025`,
                name: `Pro 300`,
                previouslyNamed: `Professional`,
                description: `Access to all Paidnice features.`,
                lookupKey: StripePricesLookupKeys.Pro300,
                currency: `USD`,
                default: true,
                limits: {
                    actions: 100,
                    emails: 1200,
                    invoices: 300,
                    contacts: 1000,
                    policies: DEFAULT_POLICY_LIMIT,
                    emailTemplates: DEFAULT_EMAIL_TEMPLATE_LIMIT,
                    users: 12,
                },
            },
            [StripePricesLookupKeys.Pro600]: {
                version: `2025`,
                name: `Pro 600`,
                previouslyNamed: `Multi`,
                description: `Access to all Paidnice features. 600 invoices + 1800 emails each month.`,
                lookupKey: StripePricesLookupKeys.Pro600,
                currency: `USD`,
                default: false,
                limits: {
                    actions: 200,
                    emails: 1800,
                    invoices: 600,
                    contacts: 1000,
                    policies: DEFAULT_POLICY_LIMIT,
                    emailTemplates: DEFAULT_EMAIL_TEMPLATE_LIMIT,
                    users: 12,
                },
            },
            [StripePricesLookupKeys.Pro1000]: {
                version: `2025`,
                name: `Pro 1000`,
                description: `Access to all Paidnice features. 1000 invoices + 4000 emails each month.`,
                lookupKey: StripePricesLookupKeys.Pro1000,
                currency: `USD`,
                default: false,
                limits: {
                    actions: 400,
                    emails: 4000,
                    invoices: 1000,
                    contacts: 1000,
                    policies: DEFAULT_POLICY_LIMIT,
                    emailTemplates: DEFAULT_EMAIL_TEMPLATE_LIMIT,
                    users: 12,
                },
            },
            [StripePricesLookupKeys.Pro2000]: {
                version: `2025`,
                name: `Pro 2000`,
                previouslyNamed: `Multi +`,
                description: `Access to all Paidnice features. 2000 invoices + 8000 emails each month.`,
                lookupKey: StripePricesLookupKeys.Pro2000,
                currency: `USD`,
                default: false,
                limits: {
                    actions: 800,
                    emails: 8000,
                    invoices: 2000,
                    contacts: 1000,
                    policies: DEFAULT_POLICY_LIMIT,
                    emailTemplates: DEFAULT_EMAIL_TEMPLATE_LIMIT,
                    users: 20,
                },
            },
            [StripePricesLookupKeys.Pro3000]: {
                version: `2025`,
                name: `Pro 3000`,
                previouslyNamed: `Multi +`,
                description: `Access to all Paidnice features. 3000 invoices + 12,000 emails each month.`,
                lookupKey: StripePricesLookupKeys.Pro3000,
                currency: `USD`,
                default: false,
                limits: {
                    actions: 800,
                    emails: 12000,
                    invoices: 3000,
                    contacts: 1000,
                    policies: DEFAULT_POLICY_LIMIT,
                    emailTemplates: DEFAULT_EMAIL_TEMPLATE_LIMIT,
                    users: 20,
                },
            },
            [StripePricesLookupKeys.Pro4000]: {
                version: `2025`,
                name: `Pro 4000`,
                previouslyNamed: `Multi +`,
                description: `Access to all Paidnice features. 4000 invoices + 16,000 emails each month.`,
                lookupKey: StripePricesLookupKeys.Pro4000,
                currency: `USD`,
                default: false,
                limits: {
                    actions: 800,
                    emails: 16000,
                    invoices: 4000,
                    contacts: 1000,
                    policies: DEFAULT_POLICY_LIMIT,
                    emailTemplates: DEFAULT_EMAIL_TEMPLATE_LIMIT,
                    users: 20,
                },
            },
            [StripePricesLookupKeys.Pro3002026]: {
                version: `2026`,
                name: `Pro 300`,
                previouslyNamed: `Professional`,
                description: `Access to all Paidnice features.`,
                lookupKey: StripePricesLookupKeys.Pro3002026,
                currency: `USD`,
                default: true,
                limits: {
                    actions: 100,
                    emails: 1200,
                    invoices: 300,
                    contacts: 1000,
                    policies: DEFAULT_POLICY_LIMIT,
                    emailTemplates: DEFAULT_EMAIL_TEMPLATE_LIMIT,
                    users: 12,
                },
            },
            [StripePricesLookupKeys.Pro3002026Annual]: {
                version: `2026`,
                name: `Pro 300 Annual`,
                previouslyNamed: `Professional`,
                description: `Access to all Paidnice features. Billed annually.`,
                lookupKey: StripePricesLookupKeys.Pro3002026Annual,
                currency: `USD`,
                default: false,
                annual: true,
                hidden: true,
                limits: {
                    actions: 100,
                    emails: 1200,
                    invoices: 300,
                    contacts: 1000,
                    policies: DEFAULT_POLICY_LIMIT,
                    emailTemplates: DEFAULT_EMAIL_TEMPLATE_LIMIT,
                    users: 12,
                },
            },
            [StripePricesLookupKeys.Pro6002026]: {
                version: `2026`,
                name: `Pro 600`,
                previouslyNamed: `Multi`,
                description: `Access to all Paidnice features. 600 invoices + 1800 emails each month.`,
                lookupKey: StripePricesLookupKeys.Pro6002026,
                currency: `USD`,
                default: false,
                limits: {
                    actions: 200,
                    emails: 1800,
                    invoices: 600,
                    contacts: 1000,
                    policies: DEFAULT_POLICY_LIMIT,
                    emailTemplates: DEFAULT_EMAIL_TEMPLATE_LIMIT,
                    users: 12,
                },
            },
            [StripePricesLookupKeys.Pro6002026Annual]: {
                version: `2026`,
                name: `Pro 600 Annual`,
                previouslyNamed: `Multi`,
                description: `Access to all Paidnice features. 600 invoices + 1800 emails each month, billed annually.`,
                lookupKey: StripePricesLookupKeys.Pro6002026Annual,
                currency: `USD`,
                default: false,
                annual: true,
                hidden: true,
                limits: {
                    actions: 200,
                    emails: 1800,
                    invoices: 600,
                    contacts: 1000,
                    policies: DEFAULT_POLICY_LIMIT,
                    emailTemplates: DEFAULT_EMAIL_TEMPLATE_LIMIT,
                    users: 12,
                },
            },
            [StripePricesLookupKeys.Pro10002026]: {
                version: `2026`,
                name: `Pro 1000`,
                description: `Access to all Paidnice features. 1000 invoices + 4000 emails each month.`,
                lookupKey: StripePricesLookupKeys.Pro10002026,
                currency: `USD`,
                default: false,
                limits: {
                    actions: 400,
                    emails: 4000,
                    invoices: 1000,
                    contacts: 1000,
                    policies: DEFAULT_POLICY_LIMIT,
                    emailTemplates: DEFAULT_EMAIL_TEMPLATE_LIMIT,
                    users: 12,
                },
            },
            [StripePricesLookupKeys.Pro10002026Annual]: {
                version: `2026`,
                name: `Pro 1000 Annual`,
                description: `Access to all Paidnice features. 1000 invoices + 4000 emails each month, billed annually.`,
                lookupKey: StripePricesLookupKeys.Pro10002026Annual,
                currency: `USD`,
                default: false,
                annual: true,
                hidden: true,
                limits: {
                    actions: 400,
                    emails: 4000,
                    invoices: 1000,
                    contacts: 1000,
                    policies: DEFAULT_POLICY_LIMIT,
                    emailTemplates: DEFAULT_EMAIL_TEMPLATE_LIMIT,
                    users: 12,
                },
            },
            [StripePricesLookupKeys.Pro20002026]: {
                version: `2026`,
                name: `Pro 2000`,
                previouslyNamed: `Multi +`,
                description: `Access to all Paidnice features. 2000 invoices + 8000 emails each month.`,
                lookupKey: StripePricesLookupKeys.Pro20002026,
                currency: `USD`,
                default: false,
                limits: {
                    actions: 800,
                    emails: 8000,
                    invoices: 2000,
                    contacts: 1000,
                    policies: DEFAULT_POLICY_LIMIT,
                    emailTemplates: DEFAULT_EMAIL_TEMPLATE_LIMIT,
                    users: 20,
                },
            },
            [StripePricesLookupKeys.Pro20002026Annual]: {
                version: `2026`,
                name: `Pro 2000 Annual`,
                previouslyNamed: `Multi +`,
                description: `Access to all Paidnice features. 2000 invoices + 8000 emails each month, billed annually.`,
                lookupKey: StripePricesLookupKeys.Pro20002026Annual,
                currency: `USD`,
                default: false,
                annual: true,
                hidden: true,
                limits: {
                    actions: 800,
                    emails: 8000,
                    invoices: 2000,
                    contacts: 1000,
                    policies: DEFAULT_POLICY_LIMIT,
                    emailTemplates: DEFAULT_EMAIL_TEMPLATE_LIMIT,
                    users: 20,
                },
            },
            [StripePricesLookupKeys.Pro30002026]: {
                version: `2026`,
                name: `Pro 3000`,
                previouslyNamed: `Multi +`,
                description: `Access to all Paidnice features. 3000 invoices + 12,000 emails each month.`,
                lookupKey: StripePricesLookupKeys.Pro30002026,
                currency: `USD`,
                default: false,
                limits: {
                    actions: 800,
                    emails: 12000,
                    invoices: 3000,
                    contacts: 1000,
                    policies: DEFAULT_POLICY_LIMIT,
                    emailTemplates: DEFAULT_EMAIL_TEMPLATE_LIMIT,
                    users: 20,
                },
            },
            [StripePricesLookupKeys.Pro30002026Annual]: {
                version: `2026`,
                name: `Pro 3000 Annual`,
                previouslyNamed: `Multi +`,
                description: `Access to all Paidnice features. 3000 invoices + 12,000 emails each month, billed annually.`,
                lookupKey: StripePricesLookupKeys.Pro30002026Annual,
                currency: `USD`,
                default: false,
                annual: true,
                hidden: true,
                limits: {
                    actions: 800,
                    emails: 12000,
                    invoices: 3000,
                    contacts: 1000,
                    policies: DEFAULT_POLICY_LIMIT,
                    emailTemplates: DEFAULT_EMAIL_TEMPLATE_LIMIT,
                    users: 20,
                },
            },
            [StripePricesLookupKeys.Pro40002026]: {
                version: `2026`,
                name: `Pro 4000`,
                previouslyNamed: `Multi +`,
                description: `Access to all Paidnice features. 4000 invoices + 16,000 emails each month.`,
                lookupKey: StripePricesLookupKeys.Pro40002026,
                currency: `USD`,
                default: false,
                limits: {
                    actions: 800,
                    emails: 16000,
                    invoices: 4000,
                    contacts: 1000,
                    policies: DEFAULT_POLICY_LIMIT,
                    emailTemplates: DEFAULT_EMAIL_TEMPLATE_LIMIT,
                    users: 20,
                },
            },
            [StripePricesLookupKeys.Pro40002026Annual]: {
                version: `2026`,
                name: `Pro 4000 Annual`,
                previouslyNamed: `Multi +`,
                description: `Access to all Paidnice features. 4000 invoices + 16,000 emails each month, billed annually.`,
                lookupKey: StripePricesLookupKeys.Pro40002026Annual,
                currency: `USD`,
                default: false,
                annual: true,
                hidden: true,
                limits: {
                    actions: 800,
                    emails: 16000,
                    invoices: 4000,
                    contacts: 1000,
                    policies: DEFAULT_POLICY_LIMIT,
                    emailTemplates: DEFAULT_EMAIL_TEMPLATE_LIMIT,
                    users: 20,
                },
            },
        },
    },
};
export function findPlanByLookupKey(lookupKey) {
    const plan = Object.values(plansV3).find(plan => {
        return Object.values(plan.prices).find(price => price.lookupKey === lookupKey);
    });
    return plan;
}
export function findPriceByLookupKey(lookupKey) {
    const plan = findPlanByLookupKey(lookupKey);
    if (!plan) {
        return null;
    }
    return plan.prices[lookupKey];
}
//# sourceMappingURL=stripeConfig.js.map